import { Tabs } from "@xola/ui-kit";
import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { XolaPartner } from "types";
import { PartnerDetails } from "./PartnerDetails";
import { PartnerTermsPage } from "./PartnerTermsPage";
import { SellerTerms } from "./SellerTerms";
import { Loader } from "@/components/Loader";

interface PartnerProfileProps {
    partner?: XolaPartner;
}

const tabs = {
    partnerProfile: "Operator Profile",
    myTerms: "My Terms",
    partnerTerms: "Operator Terms",
};

const tabKeys = Object.keys(tabs);

export const PartnerProfile = ({ partner }: PartnerProfileProps) => {
    const { tab = "partnerProfile" } = useParams<{ tab?: string }>();
    const history = useHistory();

    const changeTab = (tabIndex: number) => {
        if (partner) {
            history.push(`/distribution/operators/${partner.id}/${tabKeys[tabIndex]}`);
        }
    };

    return (
        <Tabs value={tabKeys.indexOf(tab)} onChange={changeTab}>
            <Tabs.Tab>{tabs.partnerProfile}</Tabs.Tab>
            <Tabs.Panel>
                <PartnerDetails />
            </Tabs.Panel>

            <Tabs.Tab disabled={!partner}>{tabs.myTerms} </Tabs.Tab>
            <Tabs.Panel>{partner ? <SellerTerms partner={partner} /> : <Loader />}</Tabs.Panel>

            <Tabs.Tab disabled={!partner}>{tabs.partnerTerms}</Tabs.Tab>
            <Tabs.Panel>{partner ? <PartnerTermsPage partner={partner} /> : <Loader />}</Tabs.Panel>
        </Tabs>
    );
};
